import { render, staticRenderFns } from "./OrdenesList.vue?vue&type=template&id=44576ab4&"
import script from "./OrdenesList.vue?vue&type=script&lang=js&"
export * from "./OrdenesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports